<div class="content-block">

    <!-- Content Header (Page header) -->
    
    <div class="content-header">
       <div class="container-fluid">
         <div class="row">
           <div class="col-sm-6">
             <h1 class="m-0 text-dark">Parametri </h1>
           </div><!-- /.col -->
           <div class="col-sm-6">
             <ol class="breadcrumb float-sm-right">
               <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
               <li class="breadcrumb-item">Parametri</li>
               <li class="breadcrumb-item active">Grafici</li>
             </ol>
           </div><!-- /.col -->
         </div><!-- /.row -->
       </div><!-- /.container-fluid -->
     </div>
     <!-- /.content-header -->

     <section class="col-md-12">

        <div class="card primary">
          <div class="card-header">
            <h3 class="card-title">
              <i class="fa fa-chart-pie mr-1"></i>
              Parametri grafici
            </h3>
            
          </div><!-- /.card-header -->
          <div class="card-body">
          <form>
            <div class="row">
                <div class="col-xl-6 col-sm-12 col-xs-12 mb-6">
                    <div class="dx-field">
                        <div class="dx-field-label">Logo</div>
                     
                            <dx-file-uploader
                                #logoUploader
                                selectButtonText="Selezione file"
                                labelText=""
                                accept="image/*"
                                uploadMode="useForm"
                                (change)="getLogo($event)">
                            </dx-file-uploader>

                            <img [src]="currentLogo" alt="Logo">
                        
                    </div>
                </div>


                
            </div>


            

           </form>
           
          </div><!-- /.card-body -->
          <div class="card-footer">

                    <dx-button
                        stylingMode="contained"
                        text="Salva"
                        icon="save"
                        type="success"
                        width="120"
                        (onClick)="SalvaParametri($event)">
                    </dx-button>
            </div> <!-- card-footer -->   


        </div>
        <!-- /.card -->
      </section>


</div>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="visibleLoadPanel" [showIndicator]="true"
    [showPane]="true" [shading]="true" [hideOnOutsideClick]="false" message="Salvataggio...">
</dx-load-panel>

